import { CaptableTag, getSecurityColor } from "../../utils/captableComponents";
import { securityType, shareHolderTypes } from "./ShareholdersAGTable";

export function ShareholderNameRender(data: any) {
  return (
    <div>
      <p className=" font-semibold truncate"> {data.data?.shareholderName}</p>
    </div>
  );
}

export function ShareholderTypeRender(data: any) {
  return (
    <div className="flex flex-row items-center mt-2">
      {data.data?.shareholderType && (
        <CaptableTag tagName={data.data?.shareholderType ?? "Others"} />
      )}
    </div>
  );
}

export function SecurityTypeRender(data: any) {
  return (
    <td className=" text-sm text-left py-2.5">
      <div className="">
        <p
          key={data.data?.securityType}
          className={`${getSecurityColor(
            data.data?.securityType,
          )}  text-xs text-center w-24 align-middle font-semibold leading-5 rounded-sm mb-1`}
        >
          {data.data?.securityType}
        </p>
      </div>
    </td>
  );
}

export function validateInvestments(investments: any[]): {
  isValid: boolean;
  errors: string[];
} {
  const errors: string[] = [];
  let totalFDB = 0;

  const isValidDate = (dateStr: string) => {
    const formats = [
      /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
      /^\d{2}-\d{2}-\d{4}$/, // DD-MM-YYYY
      /^\d{2}\.\d{2}\.\d{4}$/, // DD.MM.YYYY
    ];
    return formats.some((regex) => regex.test(dateStr));
  };

  investments.forEach((item, index) => {
    const rowLabel = `Row ${index + 1} - (${item.shareholderName})`;
    // if (!isValidDate(item.dateOfInvestment)) {
    //   errors.push(`${rowLabel}: Invalid dateOfInvestment format`);
    // }

    if (!["Yes", "No"].includes(item.nonPriced)) {
      errors.push(`${rowLabel}: Non Priced must be 'Yes' or 'No'`);
    }

    if (typeof item.numberOfShares !== "number" || item.numberOfShares < 0) {
      errors.push(`${rowLabel}: Number Of Shares must be a number ≥ 0`);
    }

    if (
      item.pricePerShare !== "" &&
      item.pricePerShare !== null &&
      Number.isNaN(Number(item.pricePerShare))
    ) {
      errors.push(`${rowLabel}: Price Per Share must be a number or empty`);
    }

    if (
      typeof item.securityClass !== "string" ||
      item.securityClass.trim() === ""
    ) {
      errors.push(`${rowLabel}: Security Class must be a non-empty string`);
    }

    const securityTypeValue =
      typeof item.securityType === "string"
        ? item.securityType.trim().toUpperCase()
        : "";

    if (!securityType.includes(securityTypeValue)) {
      errors.push(
        `${rowLabel}: Security Type must be one of: ${securityType.join(", ")}`,
      );
    }

    // if (
    //   typeof item.shareholderCountry !== "string" ||
    //   item.shareholderCountry.trim() === ""
    // ) {
    //   errors.push(`${rowLabel}: shareholderCountry must be a non-empty string`);
    // }

    const fdb = Number(item.shareholderFDBPercentage);
    if (Number.isNaN(fdb) || fdb < 0) {
      errors.push(
        `${rowLabel}: Shareholder FDB Percentage must be a number ≥ 0`,
      );
    } else {
      totalFDB += fdb;
    }

    if (
      typeof item.shareholderName !== "string" ||
      item.shareholderName.trim() === ""
    ) {
      errors.push(`${rowLabel}: Shareholder Name must be a non-empty string`);
    }

    if (
      !shareHolderTypes
        .map((type) => type.toLowerCase().replace(/\s+/g, ""))
        .includes(item.shareholderType.toLowerCase().replace(/\s+/g, ""))
    ) {
      errors.push(
        `${rowLabel}: Shareholder Type must be one of: ${shareHolderTypes.join(", ")}`,
      );
    }
  });
  // INFO: removed below check
  // if (totalFDB > 100) {
  //   errors.push(
  //     `Total Shareholder FDB Percentage across all rows exceeds 100 (total: ${totalFDB})`,
  //   );
  // }

  return { isValid: errors.length === 0, errors };
}
